module.exports = __webpack_public_path__ + "static/media/female-left.70d7e8e9.png";